import { getAxiosInstance } from "../ApiConfig";

async function FetchAllUserGroup() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllUserGroup`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllGroup() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCompanyUserGroups`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllGroupByAdmin() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllAdminGroups`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UserGroupDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getGroupById/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteUserGroup(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteUserGroup/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createUserGroup(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createUserGroup`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateUserGroup(payload, drawerId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateUserGroup/${drawerId}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    UserGroupDetailData,
    FetchAllUserGroup,
    FetchAllGroup,
    FetchAllGroupByAdmin,
    deleteUserGroup,
    createUserGroup,
    updateUserGroup
}